export default {
  props: {
    partnerArray: Array
  },
  data: function data() {
    return {
      label: this.value
    };
  },
  methods: {
    someSelect: function someSelect() {
      this.$emit("input", this.label);
    }
  }
};